
import { nextTick, onMounted, ref, shallowRef, watch } from '@vue/composition-api';
interface Props {
  error?: boolean;
  loading?: boolean;
  success?: boolean;
}
const __sfc_main = {};
__sfc_main.props = {
  error: {
    key: "error",
    required: false,
    type: Boolean,
    default: false
  },
  loading: {
    key: "loading",
    required: false,
    type: Boolean,
    default: false
  },
  success: {
    key: "success",
    required: false,
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  const val = ref<string[]>([]);
  const inputRef = shallowRef<HTMLInputElement[]>();
  watch(() => val.value, data => {
    if (data.length === 4) emit('update:model-value', data.toString().replace(/[,]/g, ''));
  }, {
    deep: true
  });
  onMounted(() => {
    nextTick(() => inputRef.value?.[0].focus());
  });
  function toNext(event: Event) {
    const currentTarget = (event?.target as HTMLInputElement);
    if (currentTarget.value) currentTarget.value = currentTarget.value.replace(/[^0-9]/g, '');
    if (currentTarget.value?.length === 1 && currentTarget.nextSibling) (currentTarget?.nextSibling as HTMLElement)?.focus();
  }
  return {
    val,
    inputRef,
    toNext
  };
};
export default __sfc_main;
